import { authTokenStore } from "./tokenStore";

export const getAuthHeader = (): Record<string, string> =>
  authTokenStore.getAuthHeader();
